import { GUI } from "lil-gui";
import Stats from 'three/addons/libs/stats.module.js'

export default class Debug {
  active: boolean;
  ui!: GUI;
  stats!: Stats;
  private statsInterval: number | null = null;

  constructor(debugMode?: boolean) {
    this.active = debugMode ?? (window.location.hash === "#debug");

    if (this.active) {
      this.ui = new GUI();
      this.stats = new Stats();
      document.body.appendChild(this.stats.dom);

      // Stats 업데이트를 별도의 interval로 처리
      this.statsInterval = window.setInterval(() => {
        this.stats.update();
      }, 1000 / 30); // 30fps로 제한
    }
  }

  activate() {
    this.active = true;
  }

  update() {
    // Stats 업데이트는 interval에서 처리하므로 여기서는 제거
  }

  destroy() {
    if (this.active) {
      this.active = false;
      this.ui.destroy();
      if (this.statsInterval) {
        clearInterval(this.statsInterval);
      }
      this.stats.dom.remove();
      if (document.body.contains(this.stats.dom)) {
        document.body.removeChild(this.stats.dom);
      }
    }
  }
}